export default __webpack_public_path__ + "static/media/author-7.3bd5fac2.png";